import { YouTubeVideoId } from '@customer/config/videos';
import PaywallPage from '@customer/templates/paywall-page/PaywallPage';
import { useTranslation } from 'react-i18next';

export function AssetsPaywall() {
  const { t } = useTranslation();

  return (
    <PaywallPage
      title={t('AssetsPaywallTitle')}
      subtitle={t('AssetsPaywallSubtitle')}
      description={t('AssetsPaywallDescription')}
      videoProps={{
        videoId: YouTubeVideoId.AssetDetails,
        title: t('AssetsPaywallVideoTitle'),
      }}
    />
  );
}

export default AssetsPaywall;
